import { useTranslation } from "react-i18next";

const ResumeComponent = () => {
  const { t } = useTranslation();
  const eduction = [0, 1, 2, 3];
  const experience = [0, 1, 2];
  const missions = [0, 1, 2, 3, 5, 4];
  return (
    <article className="resume active" data-page="resume">
      <header>
        <h2 className="h2 article-title">{t(`navbar.resume`)}</h2>
      </header>

      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
            </svg>
          </div>

          <h3 className="h3">{t(`general.education`)}</h3>
        </div>

        <ol className="timeline-list">
          {eduction.map((ed: any) => (
            <li className="timeline-item" key={ed}>
              <h4 className="h4 timeline-item-title">
                {t(`eduction.${ed}.title`)}
              </h4>

              <span>
                {t(`eduction.${ed}.start_date`)} —{" "}
                {t(`eduction.${ed}.end_date`)}
              </span>

              <p className="timeline-text">{t(`eduction.${ed}.description`)}</p>
            </li>
          ))}
        </ol>
      </section>

      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" />
            </svg>
          </div>

          <h3 className="h3">{t(`general.experience`)}</h3>
        </div>

        <ol className="timeline-list">
          {experience.map((ed: any) => (
            <li className="timeline-item" key={ed}>
              <h4 className="h4 timeline-item-title">
                {t(`experience.${ed}.title`)}
              </h4>

              <span>
                {t(`experience.${ed}.start_date`)} —{" "}
                {t(`experience.${ed}.end_date`)}
              </span>

              <p
                className="timeline-text"
                dangerouslySetInnerHTML={{
                  __html: t(`experience.${ed}.description`),
                }}
              ></p>
            </li>
          ))}
        </ol>
      </section>
      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"
              />
              <path
                fillRule="evenodd"
                d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z"
              />
            </svg>
          </div>

          <h3 className="h3">{t(`general.missions`)}</h3>
        </div>

        <ol className="timeline-list">
          {missions.map((ed: any) => (
            <li className="timeline-item" key={ed}>
              <h4 className="h4 timeline-item-title">
                {t(`missions.${ed}.title`)}
              </h4>
              {/*
                <span>
                  {t(`missions.${ed}.start_date`)} —{" "}
                  {t(`missions.${ed}.end_date`)}
                </span>
                */}
              <p
                className="timeline-text"
                dangerouslySetInnerHTML={{
                  __html: t(`missions.${ed}.description`),
                }}
              ></p>
            </li>
          ))}
        </ol>
      </section>
    </article>
  );
};
export default ResumeComponent;
